/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Resetpasswordsuccess2Inputs */

const zh_auth_resetpasswordsuccess2 = /** @type {(inputs: Auth_Resetpasswordsuccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`密码重置成功`)
};

const en_auth_resetpasswordsuccess2 = /** @type {(inputs: Auth_Resetpasswordsuccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Password reset successfully`)
};

const es_auth_resetpasswordsuccess2 = /** @type {(inputs: Auth_Resetpasswordsuccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contraseña restablecida correctamente`)
};

/**
* | output |
* | --- |
* | "Password reset successfully" |
*
* @param {Auth_Resetpasswordsuccess2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const auth_resetpasswordsuccess2 = /** @type {((inputs?: Auth_Resetpasswordsuccess2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Resetpasswordsuccess2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_auth_resetpasswordsuccess2(inputs)
	if (locale === "en") return en_auth_resetpasswordsuccess2(inputs)
	return es_auth_resetpasswordsuccess2(inputs)
});
export { auth_resetpasswordsuccess2 as "auth_resetPasswordSuccess" }